import { formatMoney } from '@betterment/core';
import { Separator } from '@betterment/samba-react';
import { ActivityDrawerLayout } from '@betterment/shared-components/src/components/activity/components/drawer/common/ActivityDrawerLayout';
import { DrawerListRow } from '@betterment/shared-components/src/components/activity/components/drawer/common/DrawerListRow';
import { getLatestStatus } from '@betterment/shared-components/src/components/activity/utils/statusUtils';

import { ActivityItemFragment } from '../../../../graphql/fragments/activityItem.generated';
import { ActivityItemStage } from '../../../../graphql/schema';
import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import { ActivityReportsUrl } from '../common/ActivityReportsUrl';
import { StatusSection } from '../common/StatusSection';
import { TradesList } from '../common/trades/TradesList';

type TransferGroup = NarrowTypename<ActivityItemFragment, 'ActivityItemTransferGroup'>;
export type TransferItem = TransferGroup['transferItems'][number];

export const Transfer: React.FC<{
  item: TransferGroup;
}> = ({ item }) => {
  const latestStatus = getLatestStatus(item.statuses);
  const isCanceled = latestStatus?.stage === ActivityItemStage.Canceled;
  const isCompleted = latestStatus?.stage === ActivityItemStage.Completed;

  return (
    <ActivityDrawerLayout title="Transfer">
      <DrawerListRow label="From" value={item.transferSourceAccount?.name ?? ''} />
      <Separator />
      <DrawerListRow label="To" value={item.transferDestinationAccount?.name ?? ''} />
      <Separator />
      <>
        {item.isFullTransfer ? (
          <>
            <DrawerListRow label="Requested amount" value="Full amount" />
            {isCompleted && item.amount && (
              <>
                <Separator />
                <DrawerListRow label="Final amount" value={formatMoney(item.amount)} />
              </>
            )}
          </>
        ) : (
          <>
            {item.amount && (
              <DrawerListRow label="Amount" value={formatMoney(item.amount)} shouldLineThrough={isCanceled} />
            )}
          </>
        )}
        <Separator />
      </>
      <StatusSection statuses={item.statuses} />
      {item.transferItems.length > 0 && (
        <>
          <Separator />
          <TradesList
            title="Transfer details"
            items={item.transferItems}
            toolTipMessage="We transferred your assets with minimal selling to help reduce taxes and keep your money invested."
          />
        </>
      )}
      {item.activityReportsUrl && (
        <>
          <Separator />
          <ActivityReportsUrl url={item.activityReportsUrl} />
        </>
      )}
    </ActivityDrawerLayout>
  );
};
